import { Directive, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';
import { resolveInternalAppLink } from '@shared/helpers/functions/resolve-internal-app-link';

/**
 * Routes GSTAR links inside rendered rich-text content without a full reload.
 * Modifier clicks are left to the browser so users can still open a new tab.
 */
@Directive({
  standalone: false,
  selector: '[gstarInternalLinks]',
})
export class InternalLinkNavigationDirective {
  private readonly router = inject(Router);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const anchor = (event.target as HTMLElement | null)?.closest('a');
    const internalRoute = resolveInternalAppLink(anchor?.getAttribute('href'));

    if (!internalRoute) {
      return;
    }

    event.preventDefault();
    this.router.navigateByUrl(internalRoute);
  }
}
